export const Progress = {
  baseStyle: {
    filledTrack: {
      bg: 'primary.600',
    },
  },
};

export default Progress;
